import SimpleSelect from './SimpleSelect'

export default SimpleSelect
